let enable_nlx_chat = 'true'
let nlx_bot_url = 'https://bots.studio.nlx.ai/c/TGiZCgBqRln6UwtUD7RNW/53OMvYwi_U3Tnty3FPF4h'
let nlx_api_key = 'JeDP3LuUyOb=aE6A4H1U-Wpz0_OtcBVN'
let nlx_locales = '["en-US","it-IT","fr-FR","de-DE","nl-NL"]'
function deviceAssurePlatformCheck() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    if (enable_nlx_chat && nlx_bot_url && nlx_api_key && nlx_locales){
      if(isInitNLX == false){
        initNLX();
      }
    }
    return false;
  }
  
  if (/android/i.test(userAgent)) {
    return true;
  }
  
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true;
  }
  if (enable_nlx_chat && nlx_bot_url && nlx_api_key && nlx_locales){
    if(isInitNLX == false){
      initNLX();
    }
  }
  return false;
}

function shouldRunDeviceAssure() {
    let deviceInfoStr = localStorage.getItem("esimShopifyDVInfo");
    if (deviceInfoStr) {
      try {
          deviceInfo = JSON.parse(deviceInfoStr);
          if (deviceInfo) {
            if (enable_nlx_chat && nlx_bot_url && nlx_api_key && nlx_locales){
              if(isInitNLX == false){
                initNLX();
              }
            }
            return false;
          }
      }
      catch(error) {
          localStorage.removeItem("esimShopifyDVInfo");
          shouldRunDeviceAssure();
      }
    }

    return deviceAssurePlatformCheck();
}

function loadDeviceAssure() {
    localStorage.removeItem("DV");
    DeviceValidation.getData((payload) => {
    payload.info.serverToServer = false;
    payload.info.dataCollectorKey = '21f2ca8d1c592e56d67ebf617b68658e';

    const onSuccess = (response) => {
        if (response && response.response != null) {
            try {
            let deviceInfoObj = JSON.parse(response.response);
            if (deviceInfoObj) {
                localStorage.setItem("esimShopifyDVInfo", response.response);
                deviceInfo = deviceInfoObj;
                if (enable_nlx_chat && nlx_bot_url && nlx_api_key && nlx_locales){
                  if(isInitNLX == false){
                    initNLX();
                  }
                }
            }
            }
            catch(exception) {
            }
        }
    };

    const onError = (error) => {
    };

    DeviceValidation.check(payload.info.dataCollectorKey, onSuccess, onError, payload);
    });
}

function getDeviceCompatability(deviceInfo) {
    let device = deviceInfo.deviceAtlasProperties.standardisedFullName
    let compatible = false 
    let message = ''

    if (deviceInfo.deviceAtlasProperties.standardisedFullName == "Apple iPhone"){
      device = 'iPhone'
      message = "It looks like you are using either an older iPhone not eSIM capable OR a newer iPhone we aren&#39;t able to detect yet. If you think it may be the latter, please follow the link below to confirm compatibility:"
      return {
        'compatible': compatible, 
        'device': device,
        'message': message
      }
    }

    if (deviceInfo.deviceAtlasProperties.standardisedFullName.includes("iPhone")){
      device = 'iPhone'
      if ((deviceInfo.deviceAtlasProperties.eSimCount == undefined || deviceInfo.deviceAtlasProperties.eSimCount == null) || deviceInfo.deviceAtlasProperties.eSimCount == 1){
        compatible = true
      }
      return {
        'compatible': compatible, 
        'device': device,
        'message': message
      }
    }

    if (deviceInfo.deviceAtlasProperties.standardisedFullName.includes("iPad")){
      device = 'iPad'
      message = "It looks like you are using an iPad, but we&#39;re not 100% sure which one to confirm eSIM compatibility. Please follow the link below to confirm compatibility:"
      if (deviceInfo.deviceAtlasProperties.eSimCount == 0){
        message = ''
      }
      return {
        'compatible': compatible, 
        'device': device,
        'message': message
      }
    }

    if (deviceInfo.deviceAtlasProperties.osName == "Android"){
      if (deviceInfo.deviceAtlasProperties.eSimCount == undefined || deviceInfo.deviceAtlasProperties.eSimCount == null){
        message = "It looks like you are using an Android device but we&#39;re not 100% sure which one to confirm eSIM compatibility. Please follow the link below to confirm compatibility:"
      } else if (deviceInfo.deviceAtlasProperties.eSimCount == 1){
        compatible = true
      } 
      return {
        'compatible': compatible, 
        'device': device,
        'message': message
      }
    }

    if (deviceInfo.reason == 'Desktop identified'){
      message = "It looks like you are using a non-mobile device which is likely not eSIM compatible. If you visit this webpage on your mobile we can try and detect if it is eSIM compatible. Otherwise please follow the link below to view our list of compatiable devices to see if your mobile device is listed:"
      device = 'Desktop'
      return {
        'compatible': compatible, 
        'device': device,
        'message': message
      }
    }

    message = "We have been unable to detect the device type you are using. Please follow the link below to view our list of compatible devices to see if your mobile device is listed:"
    device = 'unknown device'
    return {
      'compatible': compatible,
      'device': device,
      'message': message
    }
  }